import { Component, Input, ViewChild, input } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { ConfirmPopup, ConfirmPopupModule } from 'primeng/confirmpopup';
import { IDepartment, ISection } from '../../interfaces/models/admin.model';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { AdminService } from '../../services/admin.service';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationService } from 'primeng/api';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { DirectionService } from '../../services/direction.service';
import { TranslateModule } from '@ngx-translate/core';
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
  selector: 'app-section',
  standalone: true,
  imports: [ButtonModule, TranslateModule, FormsModule, ReactiveFormsModule, TableModule, DropdownModule, CommonModule, ConfirmPopupModule, InputTextModule],
  templateUrl: './section.component.html',
  styleUrl: './section.component.scss',
  providers: [ConfirmationService],
  animations: [
    trigger('slideDown', [
      transition(':enter', [
        style({ height: '0', opacity: 0, overflow: 'hidden' }),
        animate('300ms ease-out', style({ height: '*', opacity: 1 }))
      ]),
      transition(':leave', [
        style({ height: '*', opacity: 1, overflow: 'hidden' }),
        animate('300ms ease-in', style({ height: '0', opacity: 0 }))
      ])
    ])
  ]
})
export class SectionComponent {
  @ViewChild(ConfirmPopup) confirmPopup!: ConfirmPopup;
  @ViewChild('sectionForm') sectionForm!: FormGroup;
  isModalVisible = false;
  selectedSection = {} as ISection;
  selectedSectionId = 0
  isModalSubmitted = false;
  isDeleteSectionModalVisible = false;
  currentSectionDeletionPreview = {} as any
  unitProjects = [] as any[]
  unitProjectsForm!: FormGroup;
  employeeForm!: FormGroup;
  today!: Date;
  dir!: 'rtl' | 'ltr';
  isEmployeeDeletable = false;
  employees = [] as any[];
  activeMenuId: number | null = null;
  userOptions = [] as { label: string, id: number }[];
  @Input() sections = [] as Partial<ISection>[]
  @Input() selectedDepartment = {} as IDepartment;
  @Input() departmentOptions = [] as { label: string, id: number }[];
  @Input() selectedDepartmentId = 0;




  constructor(
    private adminService: AdminService,
    private toastr: ToastrService,
    private confirmationService: ConfirmationService,
    private directionService: DirectionService
  ) {

  }
  ngOnInit(): void {
    this.today = new Date();
    
    // Initialize forms to prevent errors
    this.unitProjectsForm = new FormGroup({});
    this.employeeForm = new FormGroup({});
    
    this.directionService.direction$.subscribe((dir) => {
      this.dir = dir;
    })
    
    // Load users for in_charge dropdown
    this.adminService.getListUsers().subscribe((response: any) => {
      const users = response['data']['users'] || [];
      this.userOptions = users.map((user: any) => ({
        label: user.name,
        id: user.id
      }));
    })
  }

  openSectionModal(sectionId: number) {

    if (!sectionId) {
      this.selectedSection = {} as ISection;
    } else {
      this.selectedSection = structuredClone(this.sections.find(x => x.id == sectionId) as ISection);
    }
    this.isModalVisible = true;
  }
  closeDepartmentModal() {
    this.isModalVisible = false;
  }
  submit() {
    this.isModalSubmitted = true;
    if (this.sectionForm.valid && !this.selectedSection.id) {
      this.adminService.createSection({ 
        name: this.selectedSection.name,
        in_charge_id: this.selectedSection.in_charge_id 
      }, this.selectedDepartmentId).subscribe((response: any) => {
        const id = response['data']['entity']['id']
        this.selectedDepartmentId = this.selectedDepartmentId;
        const newSection = { 
          id: id, 
          name: this.selectedSection.name, 
          department_name: this.selectedDepartment.name,
          in_charge_id: this.selectedSection.in_charge_id,
          in_charge_name: this.userOptions.find(u => u.id === this.selectedSection.in_charge_id)?.label
        };
        this.sections.push(newSection)
        this.toastr.success(this.dir == 'rtl' ? "تمت الاضافة " : "Added Successfully");
        this.sectionForm.reset();
        this.isModalSubmitted = false;
        this.selectedSection = {} as ISection
        this.isModalVisible = false;
      }, (err) => {
        this.toastr.error(this.dir == 'rtl' ? "لم يتم الاضافة" : "Failed to add");
      })
    }
    else if (this.sectionForm.valid && this.selectedSection.id > 0) {
      this.adminService.updateSection(this.selectedSection.id, this.selectedDepartment.id, { 
        name: this.selectedSection.name,
        in_charge_id: this.selectedSection.in_charge_id 
      }).subscribe((response: any) => {
        const updatedSection = {
          ...this.selectedSection,
          in_charge_name: this.userOptions.find(u => u.id === this.selectedSection.in_charge_id)?.label
        };
        this.sections = this.sections.map(x => {
          if (x.id == this.selectedSection.id) {
            return { ...x, ...updatedSection }
          } else {
            return x;
          }
        })
        this.toastr.success(this.dir == 'rtl' ? "تم التعديل " : "Updated Successfully");
        this.isModalVisible = false;
        this.isModalSubmitted = false;
        this.sectionForm.reset();
      }, (err) => {
        this.toastr.error(this.dir == 'rtl' ? "لم يتم التعديل" : "Failed to update");
      })
    }
    else {
      this.toastr.error(this.dir == 'rtl' ? "يرجي مراجعة البيانات" : "Please review the information");
    }
  }
  // Delete from modal (direct call)
  confirmSectionDelete(event: Event, sectionId: number) {
    this.adminService.deleteSection(sectionId, this.selectedDepartment.id).subscribe({
      next: () => {
        this.sections = this.sections.filter(x => x.id != sectionId);
        this.toastr.success(this.dir == 'rtl' ? "تم المسح بنجاح" : "Deleted Successfully", this.dir == 'rtl' ? "عملية ناجحة" : "Success");
        this.isDeleteSectionModalVisible = false;
      },
      error: (err) => {
        console.error('Delete Section Error:', err);
        const errorMsg = err?.error?.error?.message || err?.error?.message || (this.dir == 'rtl' ? 'حدث خطأ أثناء الحذف' : 'Error occurred during deletion');
        this.toastr.error(errorMsg, this.dir == 'rtl' ? "فشل" : "Failed");
      }
    })
  }
  accept() {
    this.confirmPopup.accept();
  }
  reject() {
    this.confirmPopup.reject();
  }
  openDeleteSectionModal(sectionId: number) {
    this.isDeleteSectionModalVisible = true;
    this.selectedSectionId = sectionId;


    this.adminService.getSectiontDeletionPreview(sectionId).subscribe((response: any) => {
      this.currentSectionDeletionPreview = response['data'];

      this.unitProjects = Object.values(this.currentSectionDeletionPreview['strategiesWithProjects']).reduce((acc: any[], curr: any) => {
        const mapped = curr.projects.map((x: any) => {
          return { "strategy_name": curr.strategy_name, ...x, filteredInChargeExecutives: x.inChargeExecutives }
        })

        return [...acc, ...mapped]
      },
        [] as any[]
      )
      this.isEmployeeDeletable = !this.unitProjects.length;
      const employeeGroupControls = {} as any;
      if (this.isEmployeeDeletable) {
        this.employees = this.currentSectionDeletionPreview.employees.map((x: any) => {
          return {
            ...x,
            departments: this.currentSectionDeletionPreview.departmentsForSelect,
            sections: this.currentSectionDeletionPreview.sectionsForSelect,
            filterdSections: this.currentSectionDeletionPreview.sectionsForSelect,
            roles: this.currentSectionDeletionPreview.rolesForSelect,
          }

        })
        this.employees.forEach((employee, index) => {
          employeeGroupControls[index] = new FormGroup({
            id: new FormControl(employee.id),
            department_id: new FormControl(''),
            section_id: new FormControl('', Validators.required),
            role: new FormControl('', Validators.required),

          });


          employeeGroupControls[index].get('department_id')
            ?.valueChanges.subscribe((departmentId: string) => {
              const departmentSections = this.currentSectionDeletionPreview.departmentSectionsMap[departmentId]
              this.employees[index].filterdSections = this.employees[index].sections.filter((x: any) => departmentSections.includes(x.id))
            });
        });
        this.employeeForm = new FormGroup(employeeGroupControls);
      }





      const groupControls = {} as any;
      this.unitProjects.forEach((project, index) => {
        groupControls[index] = new FormGroup({
          project_id: new FormControl(project.id),
          entity_in_charge_type: new FormControl(''),
          entity_in_charge_id: new FormControl('', Validators.required),
          executive_in_charge_id: new FormControl('', Validators.required),

        });
        groupControls[index].get('entity_in_charge_id')
          ?.valueChanges.subscribe((entityInchargeValue: string) => {

            console.log('entityInchargeValue', entityInchargeValue);

            const [entity_in_charge_type, entity_in_charge_id] = entityInchargeValue?.split('-')
            const formGroup = this.unitProjectsForm.get(String(index)) as FormGroup;
            const entity_in_charge_id_control = formGroup.get('entity_in_charge_id') as FormControl;
            const entity_in_charge_type_control = formGroup.get('entity_in_charge_type') as FormControl;
            entity_in_charge_id_control.setValue(+entity_in_charge_id);
            entity_in_charge_type_control.setValue(entity_in_charge_type);


            const unitEmployees = this.currentSectionDeletionPreview.unitEmployeesMap[entityInchargeValue]
            console.log('unitEmployees', unitEmployees);
            this.unitProjects[index].filteredInChargeExecutives = this.unitProjects[index].inChargeExecutives.filter((x: any) => unitEmployees.includes(x.id))


          });
      });
      this.unitProjectsForm = new FormGroup(groupControls);
    });



















  }
  closeDeleteModal() {
    this.isDeleteSectionModalVisible = false;
  }

  onProjectTransferSubmit() {
    const payload = { "projects": Object.values(this.unitProjectsForm.value) }
    this.adminService.transferSectionProjects(this.selectedSectionId, payload).subscribe((response: any) => {
      this.isEmployeeDeletable = true;
      this.unitProjects = [];
      this.toastr.success(response['data']['message'])
    })
  }
  onEmployeeTransferSubmit() {


    const payload = { "employees": Object.values(this.employeeForm.value) }
    this.adminService.transferSectionEmployees(this.selectedDepartmentId, payload).subscribe((response: any) => {
      this.employees = []
      this.toastr.success(response['data']['message'])
    })
  }
  
  toggleMenu(event: Event, sectionId: number) {
    event.stopPropagation();
    this.activeMenuId = this.activeMenuId === sectionId ? null : sectionId;
  }

  closeMenu() {
    this.activeMenuId = null;
  }

  closeAllMenus() {
    this.activeMenuId = null;
  }
}
